import newImobiliariaLogo from '../../assets/images/new_imobiliaria/new_imobiliaria_logo.png';
import newImobiliariaMark from '../../assets/images/new_imobiliaria/new_imobiliaria.png';
import zipLogo from '../../assets/images/logo.png';

// Imobiliárias das telas de realEstate (cadastro de prestador e termos). Enquanto
// isso não vem da API, fica aqui: cada empresa tem seus ids e sua identidade
// visual. Quem lê e aplica esta configuração é o screens/realEstate/useCompany.js.
//
// ids: o companyId da empresa em cada ambiente, um só ou uma lista quando a
// empresa tiver mais de um (production: ['id-1', 'id-2']). O nome do ambiente é
// só para leitura; a tela procura o id da URL em todos eles, então o mesmo
// arquivo serve para qualquer build. Maiúsculas e minúsculas tanto faz.
//
// Para uma empresa nova: coloque as imagens em assets/images/<empresa>/, importe
// aqui e adicione a entrada em companies. No tema só é preciso informar o que
// muda; o que faltar vem da empresa marcada com isDefault.
//
// isDefault: a empresa usada quando a URL não traz id, ou traz um id que não
// está aqui. Deve haver exatamente uma.
//
// colors vira variável CSS (--sp-<nome>) usada no serviceProvider.scss:
//   heroBackground / heroText   faixa do topo com o logo
//   primary / onPrimary         botão principal, etapa ativa, checkbox e ícones de destaque,
//                               e o texto que fica sobre eles
//   text                        texto em geral
//   background                  fundo da página
//
// logoScale multiplica a largura do logo no topo (--sp-logo-scale). Logos menos
// alongados que o da New precisam de menos que 1 para caber na faixa.
export const companies = [
  {
    // Empresa de teste, com as cores da ZIP Condomínio (styles/_variables.scss).
    ids: {
      development: 'a1b2c3d4-0000-4000-8000-000000000001',
    },
    theme: {
      name: 'ZIP Condomínio',
      shortName: 'ZIP Condomínio',
      logo: zipLogo,
      logoScale: 0.6,
      watermark: null,
      colors: {
        heroBackground: '#dac0ef',
        heroText: '#2E2E2E',
        primary: '#672CB0',
        onPrimary: '#FFF',
        text: '#2E2E2E',
      },
    },

  },
  {
    // New Imobiliária, também o tema padrão.
    isDefault: true,
    ids: {
      newImobiliariaPRD: '9799642-f248-4e27-bed7-53ff02c05fe8',
      production: 'fdc3c2c6-bc8c-4dda-8b9c-8cb219abb619',
      homolog: 'fdc3c2c6-bc8c-4dda-8b9c-8cb219abb619',
      development: '029a3a2f-2587-44df-a934-9dae38a85cc1',
    },
    theme: {
      name: 'New Soluções Imobiliárias',
      shortName: 'New Imobiliária',
      logo: newImobiliariaLogo,
      logoScale: 1,
      watermark: newImobiliariaMark,
      colors: {
        heroBackground: '#1D1D1B',
        heroText: '#fff',
        primary: '#050505',
        onPrimary: '#fff',
        text: '#050505',
        background: '#f4f4f4',
      },
    },
  },
];
